import Benefit1 from '../../images/Group_402.png';
import Benefit2 from '../../images/Group_404.png';
import Benefit3 from '../../images/Group_407.png';
import Benefit4 from '../../images/Group_409.png';
import Benefit5 from '../../images/Group_411.png';
import './JobBenefits.scss';

function JobBenefits() {
    return (
        <div className="job-benefits-wrp wrapper">
            <div className="job-benefits-title">Job Benefits</div>
            <div className="job-benefits-container">
                <div className="job-benefit-container">
                    <img src={Benefit1} alt='benefit'/>
                    <div className="benefit-content-wrp">
                        <div className="benefit-title">Set Your Target</div>
                        <div className="benefit-content">Since this is a part-time job, you won't be provided with trict targets. Based on your available time, set it for yourself and start working.</div>
                    </div>
                </div>
                <div className="job-benefit-container">
                    <img src={Benefit2} alt='benefit'/>
                    <div className="benefit-content-wrp">
                        <div className="benefit-title">Set Your Target</div>
                        <div className="benefit-content">No need to Work Daily. You can Work at your own time, as per your Wish.</div>
                    </div>
                </div>
                <div className="job-benefit-container">
                    <img src={Benefit3} alt='benefit'/>
                    <div className="benefit-content-wrp">
                        <div className="benefit-title">Freedom To Work Anytime From Anywhere</div>
                        <div className="benefit-content">You won't have any fixed time for going to the office. Just work from any place that you find comfortable with no time restrictions.</div>
                    </div>
                </div>
                <div className="job-benefit-container">
                    <img src={Benefit4} alt='benefit'/>
                    <div className="benefit-content-wrp">
                        <div className="benefit-title">Dedicated Customer Support</div>
                        <div className="benefit-content">We have 24 x 7 support available for answering your queries and helping you deal with any work- related issue on our platform.</div>
                    </div>
                </div>
                <div className="job-benefit-container">
                    <img src={Benefit5} alt='benefit'/>
                    <div className="benefit-content-wrp">
                        <div className="benefit-title">Quick update on work</div>
                        <div className="benefit-content">Things like approval of your job application or updates on the work you have submitted are done quickly on our website. So you will not have to wait for a lot of time.</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default JobBenefits;